import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import FilterWrapper from './../FilterWrapper';
import { useLanguage } from './../../../../../../context/LanguageContext';

const NumberRangeFilter = props => {
  const { labels } = useLanguage();
  const FILTER_BAR = labels.FILTER_BAR || {};
  const [state, setState] = useState({
      dropOpen: false,
      selectedItems: [],
      startInclusive: props.startInclusive,
      endInclusive: props.endInclusive
    });

  useEffect(() => {
    setSelectedItems([state.startInclusive, state.endInclusive]);
  },[])

  useEffect(() => {
    let initialDates = [props.startInclusive, props.endInclusive];
    initialDates = initialDates.filter(item => item);

    setState(state => (
      {
        ...state,
        startInclusive: props.startInclusive,
        endInclusive: props.endInclusive,
        selectedItems: initialDates
      }));
    
  },[props.startInclusive, props.endInclusive, state.dropOpen])

  const onNumberChange = (event, id) => {
    event.persist();
    setState(state => ({ ...state, [id]: event.target.value }));
    setSelectedItems([state.startInclusive, state.endInclusive]);
  }

  const handleNumberEntry = e => {
    if(e.key === '+' || e.key ==='-'|| e.key==='.' ){
      e.preventDefault();
    }
  };

  const onCloseFilter = () => {
    let { startInclusive, endInclusive } = state;
    props.updateLocalFilterPayload({
      [props.filterKey]: {
        startInclusive: startInclusive || null,
        endInclusive: endInclusive || null
      }
    });
  }

  const setSelectedItems = (items) => {
    items = items.filter(item => item);
    setState(state => ({ ...state, selectedItems: items }));
  }

  const filterWrapperProps = {
    changesInFilter: state.selectedItems.length,
    id: props.id,
    isUserAdded: props.isUserAdded,
    name: props.name,
    onCloseFilter: onCloseFilter,
    removeFilter: props.removeFilter,
  };

  return (
    <FilterWrapper
      {...filterWrapperProps}
    >
      <div style={{ display: 'flex' }}>
        <TextField
          id="startInclusive"
          type='number'
          inputProps={{min:0}}
          onKeyPress={e => handleNumberEntry(e)}
          className="search-field-date"
          label={FILTER_BAR.DATE.FROM}
          style={{ fontSize: '12px' }}
          onChange={(e) => onNumberChange(e, 'startInclusive')}
          value={state.startInclusive}
        />
        <TextField
          id="endInclusive"
          type='number'
          inputProps={{min:0}}
          onKeyPress={e => handleNumberEntry(e)}
          className="search-field-date"
          label={FILTER_BAR.DATE.TO}
          style={{ fontSize: '12px' }}
          onChange={(e) => onNumberChange(e, 'endInclusive')}
          value={state.endInclusive}
          variant="standard"
        />
      </div>
    </FilterWrapper>
  );
}

NumberRangeFilter.propTypes = {
  startInclusive: PropTypes.any,
  endInclusive: PropTypes.any,
  filterKey: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  name: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
  updateLocalFilterPayload: PropTypes.func.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
};

NumberRangeFilter.defaultProps = {
  isUserAdded: false,
  items: [],
  removeFilter: () => {},
  startInclusive: null,
  endInclusive: null
};

export default NumberRangeFilter;
